<template>
    <div>
        <gmap-map :center="markers[0] || center" :zoom="zoom" :style="{height: height}" style="width: 100%">
            <gmap-marker v-if="markers.length"
                         :key="index"
                         v-for="(m, index) in markers"
                         :position="m"
                         @click="setCenter(m)"
            ></gmap-marker>
        </gmap-map>
    </div>
</template>

<script>
export default {
  name: 'GoogleMap',
  data() {
    return {
      // default to Montreal to keep it simple
      // change this to whatever makes sense
      places: [],
      currentPlace: null,
      mapMarkers: [],
      center: { lat: 10, lng: 10 }
    };
  },
  props: ['width', 'height', 'search', 'location', 'markers', 'zoom'],
  methods: {
    setCenter(oldCenter) {
      this.center = { lat: parseInt(oldCenter.latitude), lng: parseInt(oldCenter.longitude) };
    }
  }
};
</script>
